import { Injectable } from '@angular/core';
import { IdentityType } from './identity';
import { HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';

let identityUrl = CONFIG.baseUrls.identities;

@Injectable()
export class IdentityService {
  constructor(
    private httpGeneralService: HttpGeneralService) {
  }

  addIdentity(identity: IdentityType) {
    return this.httpGeneralService.add(identity, identityUrl)

  }

  deleteIdentity(identity: IdentityType) {
    return this.httpGeneralService.delete<number>(identity.code, `${identityUrl}`);

  }
  getIdentities() {
    return this.httpGeneralService.getWith(`${identityUrl}/all`);
  }

  getIdentity(id: number) {
    return this.httpGeneralService.get(id, identityUrl);

  }

  updateIdentity(identity: IdentityType) {
    return this.httpGeneralService.update<IdentityType>(identity.code, identity, identityUrl);
  }


}


